import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCustomStyles } from '../../hooks';

const FormDialog = ({ id, showDialog, title, form, onSubmit, onClose, isLoading, children }) => {
    const { t } = useTranslation();
    const classes = useCustomStyles();

    const { handleSubmit } = form;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog open={showDialog} onClose={handleClose} PaperProps={{ style: { minWidth: '600px' } }}>
            <form id={id} onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    <span>{title}</span>
                </DialogTitle>
                <DialogContent style={{ paddingTop: '1rem' }}>
                    <Grid container spacing={3}>
                        {children}
                    </Grid>
                </DialogContent>
                <DialogActions sx={classes.dialogActions}>
                    <Button onClick={handleClose} variant="outlined">
                        {t('action.cancel')}
                    </Button>
                    <Button type="submit" variant="contained" disabled={isLoading}>
                        {t('action.create')}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default FormDialog;
